import React from 'react';
import { BookOpen, Check, Star, Gift, Monitor, Palette, BarChart, Shield } from 'lucide-react';
export function ProductSection() {
  return <section className="w-full" data-id="element-345">
      {/* Product Presentation */}
      <div className="bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-346">
        <div className="max-w-5xl mx-auto" data-id="element-347">
          <div className="text-center mb-12" data-id="element-348">
            <h2 className="text-3xl sm:text-5xl font-black text-navy mb-4" data-id="element-349">
              RUTA IT USA: EL SALTO DE $0 A $70K
            </h2>
            <h3 className="text-xl sm:text-2xl font-medium text-brandBlue mb-8" data-id="element-350">
              La Guía Maestra para Inmigrantes Hispanos en EE.UU.
            </h3>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-351">
              Una guía digital completa, paso a paso, que te lleva desde tu
              situación actual hasta tu primer empleo en tecnología, usando las
              certificaciones profesionales de Google como trampolín.
            </p>
          </div>

          {/* Offer Stack */}
          <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 sm:p-10 mb-16" data-id="element-352">
            <div className="flex items-center mb-8 pb-6 border-b border-gray-200" data-id="element-353">
              <BookOpen className="h-10 w-10 text-brandBlue mr-4" data-id="element-354" />
              <h3 className="text-2xl sm:text-3xl font-bold text-navy" data-id="element-355">
                El Libro Digital Completo{' '}
                <span className="text-brandRed line-through text-lg ml-2" data-id="element-356">
                  ($15,99 valor)
                </span>
              </h3>
            </div>

            <p className="text-xl font-medium text-gray-700 mb-8" data-id="element-357">
              Todo el sistema en un solo PDF accionable:
            </p>

            <div className="space-y-8" data-id="element-358">
              {/* Chapter 1 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-brandBlue" data-id="element-359">
                <h4 className="text-xl font-bold text-navy mb-3" data-id="element-360">
                  🟦 Capítulo 1: La Nueva Economía de las Credenciales
                </h4>
                <ul className="space-y-2 text-gray-600" data-id="element-361">
                  <li className="flex items-start" data-id="element-362">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-363" />{' '}
                    Por qué el título universitario ya no es el único camino en
                    EE.UU.
                  </li>
                  <li className="flex items-start" data-id="element-364">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-365" />{' '}
                    Cómo funciona el "Puente de Certificación" y por qué es tu
                    mejor opción.
                  </li>
                </ul>
              </div>

              {/* Chapter 2 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-brandRed" data-id="element-366">
                <h4 className="text-xl font-bold text-navy mb-4" data-id="element-367">
                  🟥 Capítulo 2: Elige Tu Ruta (Con Links de Inscripción)
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-368">
                  <div className="bg-gray-50 p-3 rounded flex items-center" data-id="element-369">
                    <Monitor className="h-5 w-5 text-brandBlue mr-3" data-id="element-370" />
                    <div data-id="element-371">
                      <span className="font-bold" data-id="element-372">IT Support</span> <br data-id="element-373" />
                      <span className="text-sm text-green-600 font-medium" data-id="element-374">
                        $50k-$60k/año
                      </span>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded flex items-center" data-id="element-375">
                    <Palette className="h-5 w-5 text-purple-500 mr-3" data-id="element-376" />
                    <div data-id="element-377">
                      <span className="font-bold" data-id="element-378">UX Design</span> <br data-id="element-379" />
                      <span className="text-sm text-green-600 font-medium" data-id="element-380">
                        $65k-$80k/año
                      </span>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded flex items-center" data-id="element-381">
                    <BarChart className="h-5 w-5 text-brandGold mr-3" data-id="element-382" />
                    <div data-id="element-383">
                      <span className="font-bold" data-id="element-384">Data Analytics</span> <br data-id="element-385" />
                      <span className="text-sm text-green-600 font-medium" data-id="element-386">
                        $60k-$75k/año
                      </span>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded flex items-center" data-id="element-387">
                    <Shield className="h-5 w-5 text-brandRed mr-3" data-id="element-388" />
                    <div data-id="element-389">
                      <span className="font-bold" data-id="element-390">Cybersecurity</span> <br data-id="element-391" />
                      <span className="text-sm text-green-600 font-medium" data-id="element-392">
                        $70k-$90k+/año
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Chapter 3 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-brandGold" data-id="element-393">
                <h4 className="text-xl font-bold text-navy mb-3" data-id="element-394">
                  🟨 Capítulo 3: Cómo Estudiar Gratis o por Menos de $150
                </h4>
                <ul className="space-y-2 text-gray-600" data-id="element-395">
                  <li className="flex items-start" data-id="element-396">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-397" />{' '}
                    El secreto de la "Financial Aid" de Coursera que casi nadie
                    conoce.
                  </li>
                  <li className="flex items-start" data-id="element-398">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-399" />{' '}
                    Cómo terminar en 90 días invirtiendo menos de $150 total.
                  </li>
                </ul>
              </div>

              {/* Chapter 4 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-green-500" data-id="element-400">
                <h4 className="text-xl font-bold text-navy mb-3" data-id="element-401">
                  🟩 Capítulo 4: Inglés Técnico de Supervivencia
                </h4>
                <ul className="space-y-2 text-gray-600" data-id="element-402">
                  <li className="flex items-start" data-id="element-403">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-404" />{' '}
                    El Diccionario de Poder: las 50 palabras que necesitas
                    dominar.
                  </li>
                  <li className="flex items-start" data-id="element-405">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-406" />{' '}
                    Scripts exactos para llamadas de soporte técnico en inglés.
                  </li>
                  <li className="flex items-start" data-id="element-407">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-408" />{' '}
                    Método de inmersión pasiva para aprender mientras trabajas.
                  </li>
                </ul>
              </div>

              {/* Chapter 5 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-brandBlue" data-id="element-409">
                <h4 className="text-xl font-bold text-navy mb-3" data-id="element-410">
                  🟦 Capítulo 5: Guía Maestra del Currículum USA (Formato ATS)
                </h4>
                <ul className="space-y-2 text-gray-600 mb-4" data-id="element-411">
                  <li className="flex items-start" data-id="element-412">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-413" />{' '}
                    Estructura exacta del CV americano (sin foto, sin diseño).
                  </li>
                  <li className="flex items-start" data-id="element-414">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-415" />{' '}
                    Cómo traducir experiencia en construcción o limpieza a
                    habilidades técnicas.
                  </li>
                </ul>
                <p className="font-medium text-navy mt-4 mb-2" data-id="element-416">
                  Directorio de agencias de reclutamiento:
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-417">
                  <span className="bg-blue-100 text-blue-800 text-xs font-bold px-2.5 py-0.5 rounded" data-id="element-418">
                    Robert Half
                  </span>
                  <span className="bg-red-100 text-red-800 text-xs font-bold px-2.5 py-0.5 rounded" data-id="element-419">
                    TEKsystems
                  </span>
                  <span className="bg-yellow-100 text-yellow-800 text-xs font-bold px-2.5 py-0.5 rounded" data-id="element-420">
                    Insight Global
                  </span>
                </div>
              </div>

              {/* Chapter 6 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-brandRed" data-id="element-421">
                <h4 className="text-xl font-bold text-navy mb-3" data-id="element-422">
                  🟥 Capítulo 6: El Consorcio de Empleadores VIP
                </h4>
                <p className="text-gray-600 mb-4" data-id="element-423">
                  La lista completa de empresas que buscan graduados de Google y
                  cómo acceder al portal de empleo exclusivo.
                </p>
                <div className="grid grid-cols-2 gap-2 text-sm text-gray-600" data-id="element-424">
                  <div data-id="element-425">
                    <span className="text-brandBlue font-bold" data-id="element-426">
                      🔵 Tecnología:
                    </span>{' '}
                    Google, Dell, Intel...
                  </div>
                  <div data-id="element-427">
                    <span className="text-brandRed font-bold" data-id="element-428">
                      🔴 Finanzas:
                    </span>{' '}
                    Bank of America, Deloitte...
                  </div>
                  <div data-id="element-429">
                    <span className="text-brandGold font-bold" data-id="element-430">🟡 Retail:</span>{' '}
                    Target, Walmart, Best Buy...
                  </div>
                  <div data-id="element-431">
                    <span className="text-green-600 font-bold" data-id="element-432">
                      🟢 Salud/Media:
                    </span>{' '}
                    CVS Health, Hulu...
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}